const AVAILABLE_GENRES = [
  'action',
  'adventure',
  'arcade',
  'card',
  'racing',
  'simulation',
  'sport',
  'strategy',
];

module.exports = {
  AVAILABLE_GENRES,
};
